var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H0V2h1v4.109C2.013 2.916 5.036.625 8.5.625c3.506 0 6.621 2.36 7.574 5.739l-.963.271A6.9 6.9 0 0 0 8.5 1.624C5.274 1.625 2.484 3.9 1.792 7H6zm5 1v1h4.208c-.693 3.101-3.479 5.375-6.708 5.375a6.895 6.895 0 0 1-6.611-5.011l-.963.271A7.9 7.9 0 0 0 8.5 16.374c3.459 0 6.475-2.28 7.5-5.482V15h1V9z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.svg";